export default "__VITE_ASSET__BHJlYWh3__"